var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessageSmall = function SvgMessageSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#292f37",
    clipPath: "url(#message-small_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0h-22A5.5 5.5 0 0 0 0 5.5V22a5.5 5.5 0 0 0 5.5 5.5h3.988l6.12 5.174a1.375 1.375 0 0 0 1.776 0l6.128-5.174H27.5A5.5 5.5 0 0 0 33 22V5.5A5.5 5.5 0 0 0 27.5 0m2.75 22a2.75 2.75 0 0 1-2.75 2.75h-3.988a2.75 2.75 0 0 0-1.775.65L16.5 29.824 11.265 25.4a2.75 2.75 0 0 0-1.778-.65H5.5A2.75 2.75 0 0 1 2.75 22V5.5A2.75 2.75 0 0 1 5.5 2.75h22a2.75 2.75 0 0 1 2.75 2.75zM9.625 9.625H16.5a1.374 1.374 0 0 0 .972-2.347 1.38 1.38 0 0 0-.972-.403H9.625a1.374 1.374 0 0 0-.972 2.347c.258.258.608.403.972.403"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#message-small_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.375 17.875H9.625a1.374 1.374 0 0 0-.972 2.347c.258.258.608.403.972.403h13.75a1.374 1.374 0 0 0 .972-2.347 1.38 1.38 0 0 0-.972-.403"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "message-small_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33v33H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "message-small_svg__b",
    d: "M23.375 12.375H9.625a1.374 1.374 0 0 0-.972 2.347c.258.258.608.403.972.403h13.75a1.374 1.374 0 0 0 .972-2.347 1.38 1.38 0 0 0-.972-.403"
  }))));
};
export default SvgMessageSmall;